import React, { memo, useCallback, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Button, Col, Form, Input, Row, Space, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { COMPANY_ACTION } from '@/constants/company';
import { hideModal } from '@/store/actions/modalsActions';
import Modal from '@/views/modals/Modal';
import statusType from '@/store/constants/statusType';

import { MODALS } from '..';

const { Title, Text } = Typography;

const ConfirmCompanyRefine = props => {
  const { onOk } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [comment, setComment] = useState();

  const status = useSelector(state => state.company?.[COMPANY_ACTION.SEND_FOR_REWORK]?.status);
  const handleChangeComment = useCallback(event => {
    const { value } = event.target;
    setComment(value);
  }, []);

  const handleClickNo = useCallback(() => {
    dispatch(hideModal(MODALS.ConfirmCompanyRefine));
  }, [dispatch]);

  const handleClickYes = useCallback(() => {
    if (onOk) {
      onOk(comment);
    }
  }, [onOk, comment]);

  return (
    <Modal name={MODALS.ConfirmCompanyRefine} width={468}>
      <Row gutter={[0, 22]}>
        <Col span={24}>
          <Title level={4}>{t('modal.confirm-company-refine.title')}</Title>
          <Text>{t('modal.confirm-company-refine.description')}</Text>
        </Col>
        <Col span={24}>
          <Form layout="vertical">
            <Form.Item label={t('modal.confirm-company-refine.reason')}>
              <Input.TextArea placeholder={t('placeholder.comment')} onChange={handleChangeComment} />
            </Form.Item>
          </Form>
        </Col>
        <Col span={24}>
          <Row justify="end">
            <Space>
              <Button shape="round" onClick={handleClickNo}>
                {t('modal.confirm-company-refine.button.no')}
              </Button>
              <Button type="primary" shape="round" loading={status === statusType.LOADING} onClick={handleClickYes}>
                {t('modal.confirm-company-refine.button.yes')}
              </Button>
            </Space>
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

export default memo(ConfirmCompanyRefine);
